// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_root__2naSn","input":"checkbox_input__oLGcu"};